import { createFileRoute, retainSearchParams } from "@tanstack/react-router"
import { fallback, zodValidator } from "@tanstack/zod-adapter"
import { z } from "zod"

import PermissionContentWrapper from "@/components/PermissionWrapper/PermissionContentWrapper"
import { PermissionActionType } from "@/constants/permissions"
import {
  AssosiatedProductType,
  ComputedProductStatus,
  EquivalencyGroupSortField,
  EquivalencyType,
  SortingOrder,
} from "@/graphql/codegen/graphql"
import EquivalentProductsContainer from "@/screens/ManageProducts/components/EquivalentProductGroups/containers/EquivalentProductsContainer"

const equivalentProductsSearchSchema = z.object({
  query: fallback(z.string().optional().default(""), ""),
  equivalentTypes: fallback(z.array(z.nativeEnum(EquivalencyType)).optional(), [
    EquivalencyType.Chemical,
    EquivalencyType.Functional,
  ]),
  productStatuses: z.array(z.nativeEnum(ComputedProductStatus)).optional(),
  associationTypes: z.array(z.nativeEnum(AssosiatedProductType)).optional(),
  field: fallback(z.nativeEnum(EquivalencyGroupSortField), EquivalencyGroupSortField.Name),
  order: fallback(z.nativeEnum(SortingOrder), SortingOrder.Asc),
})

export const Route = createFileRoute("/app/admin/manage-products/_layout/equivalents")({
  validateSearch: zodValidator(equivalentProductsSearchSchema),
  search: {
    middlewares: [
      retainSearchParams(["query", "equivalentTypes", "productStatuses", "associationTypes", "field", "order"]),
    ],
  },
  component: () => (
    <PermissionContentWrapper permissions={[PermissionActionType.EQUIVALENT_MAINTENANCE]}>
      <EquivalentProductsContainer />
    </PermissionContentWrapper>
  ),
})
